const FOCUS_KEY = "isx_focus_mode";
const DIGEST_KEY = "isx_focus_digest";
const HANDSET_MEDIA_QUERY = "(max-width: 639px)";

const isHandset = () => window.matchMedia(HANDSET_MEDIA_QUERY).matches;

const loadDigest = () => {
  try {
    return JSON.parse(localStorage.getItem(DIGEST_KEY) || "[]");
  } catch (_error) {
    return [];
  }
};

const saveDigest = (digest) => {
  localStorage.setItem(DIGEST_KEY, JSON.stringify(digest));
  window.dispatchEvent(new CustomEvent("focus-digest:updated", { detail: digest }));
};

const FocusModeHook = {
  mounted() {
    this.toggleBtn = this.el.querySelector("[data-focus-toggle]");
    this.digestBtn = this.el.querySelector("[data-focus-digest-toggle]");
    this.digestPanel = this.el.querySelector("[data-focus-digest-panel]");
    this.digestList = this.el.querySelector("[data-focus-digest-list]");
    this.clearBtn = this.el.querySelector("[data-focus-clear]");

    this.onToggleClick = () => this.toggle();
    this.onDigestToggleClick = () => this.toggleDigest();
    this.onClearClick = () => this.clearDigest();
    this.onDigestUpdated = () => this.render();
    this.mediaQuery = window.matchMedia(HANDSET_MEDIA_QUERY);
    this.onViewportChange = () => this.handleViewportChange();

    this.toggleBtn?.addEventListener("click", this.onToggleClick);
    this.digestBtn?.addEventListener("click", this.onDigestToggleClick);
    this.clearBtn?.addEventListener("click", this.onClearClick);

    if (this.mediaQuery.addEventListener) {
      this.mediaQuery.addEventListener("change", this.onViewportChange);
    } else {
      this.mediaQuery.addListener(this.onViewportChange);
    }

    window.addEventListener("focus-digest:updated", this.onDigestUpdated);

    this.handleViewportChange();
    this.render();
  },
  destroyed() {
    this.toggleBtn?.removeEventListener("click", this.onToggleClick);
    this.digestBtn?.removeEventListener("click", this.onDigestToggleClick);
    this.clearBtn?.removeEventListener("click", this.onClearClick);
    window.removeEventListener("focus-digest:updated", this.onDigestUpdated);

    if (this.mediaQuery?.removeEventListener) {
      this.mediaQuery.removeEventListener("change", this.onViewportChange);
    } else if (this.mediaQuery?.removeListener) {
      this.mediaQuery.removeListener(this.onViewportChange);
    }
  },
  handleViewportChange() {
    if (!isHandset()) return;

    // Focus mode controls are hidden on handset. Ensure hidden state
    // cannot leave focus batching active with no visible toggle.
    localStorage.setItem(FOCUS_KEY, "false");
    document.body.dataset.focusMode = "false";
    this.digestPanel?.classList.add("hidden");
  },
  toggle() {
    if (isHandset()) return;

    const enabled = localStorage.getItem(FOCUS_KEY) === "true";
    localStorage.setItem(FOCUS_KEY, (!enabled).toString());
    document.body.dataset.focusMode = (!enabled).toString();
    this.render();
  },
  toggleDigest() {
    if (!this.digestPanel || isHandset()) return;
    this.digestPanel.classList.toggle("hidden");
  },
  clearDigest() {
    saveDigest([]);
    this.render();
  },
  render() {
    const handset = isHandset();
    const enabled = !handset && localStorage.getItem(FOCUS_KEY) === "true";

    if (handset && localStorage.getItem(FOCUS_KEY) === "true") {
      localStorage.setItem(FOCUS_KEY, "false");
      document.body.dataset.focusMode = "false";
    }

    if (this.toggleBtn) {
      this.toggleBtn.textContent = enabled ? "Focus: On" : "Focus: Off";
    }

    const digest = loadDigest();
    if (this.digestBtn) {
      this.digestBtn.textContent = `Digest (${digest.length})`;
    }

    if (this.digestList) {
      this.digestList.innerHTML = "";
      digest.forEach((entry) => {
        const item = document.createElement("li");
        item.className = "text-xs text-isx-white/90";
        item.textContent = entry.message;
        this.digestList.appendChild(item);
      });
    }
  },
};

export default FocusModeHook;
export { loadDigest, saveDigest, FOCUS_KEY, DIGEST_KEY };
